import styled from "styled-components";
import {TiThMenu} from "react-icons/ti";
import logo from '../logo.png';
import {NavigationButton} from "../elements/Button";

const StyledNavigation = styled.div`
    width: 100%;
    height: 80px;
    //background-color: #35644c;
    position: absolute;
    z-index: 10;
`;

const Logo = styled.img`
    width: 120px;
    margin-top: 20px;
    margin-left: 15%;
    cursor: pointer;

    &:hover {
        opacity: .9;
    }
`;

const MenuIcon = styled(TiThMenu)`
    font-size: 30px;
    width: 120px;
    margin-top: 35px;
    float: right;
    color: #ffffea;
    margin-right: 15%;
    cursor: pointer;

    &:hover {
        opacity: .9;
    }
`;

function Navigation() {
    return (
        <StyledNavigation>
            <Logo src={logo} alt="EPDM Trading logo"/>
            {/*<MenuIcon/>*/}
            {/*<NavigationButton label={"Свържете се с нас"}/>*/}
        </StyledNavigation>
    );
}

export default Navigation;
